import { TemporaryTokenManager } from '../cobler';
import { AuthToken } from './AuthTokenKeys';

export { AuthToken };

export const setAuthCookies = (refreshToken: string, accessToken?: string) => {
  localStorage.setItem(AuthToken.REFRESH_TOKEN, refreshToken);

  if (accessToken) {
    localStorage.setItem(AuthToken.ACCESS_TOKEN, accessToken);
  }
};

export const deleteAuthCookies = () => {
  localStorage.removeItem(AuthToken.REFRESH_TOKEN);
  localStorage.removeItem(AuthToken.ACCESS_TOKEN);
  TemporaryTokenManager.deleteTemporaryToken();
};

// Os mesmos headers da primitiva de `@cobliteam/api/session`, para as duas camadas mandarem a sessão igual.
export { getAuthHeaders } from '@cobliteam/api/session';
